/**
 * @componentName getBaseUrl
 */
export default function getBaseUrl() {
  const base = document.querySelector('base');

  if (base) {
    return base.href;
  }

  const [baseUrl] = window.location.href.split('#');

  return baseUrl;
}
